<template>
    <div class="w-100">
        <select class="form-control w-100" v-bind:name="getFieldName()" v-model="value" multiple="true"
                v-on:change="change">
            <option class="form-checkbox w-100" v-for="key in domainValuesOrder" :value="key" :key="key">{{ domainValues[key] }}</option>
        </select>
    </div>
</template>

<script>
import wBase from './wBase'
import {crud, choiceMixin, wSelectMixin, wCheckboxMixin} from 'crud-vue-core'

crud.conf['w-multi-select'] = {
    resources : [
        "https://unpkg.com/bootstrap-multiselect@1.1.0/dist/js/bootstrap-multiselect.js",
        "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-multiselect/0.9.15/css/bootstrap-multiselect.css"
    ],
    value:[],
    defaultValue : [],
    domainValues:{},
    domainValuesOrder : [],
    enableFiltering : true,
    numberDisplayed :3,
    pluginOptions : null,
};

export default {
  name: 'w-multi-select',
  extends: wBase,
  mixins: [choiceMixin, wCheckboxMixin],
    methods:{
        _ready() {
            let that = this;
            let pgConf = {
                //buttonClass : 'form-control',
                buttonWidth:'100%',
                allSelectedText: that.translate('app.all-selected'),
                nSelectedText: that.translate('app.selected'),
                nonSelectedText: that.translate('app.none-selected'),
                selectAllText:that.translate('app.select-all'),
                numberDisplayed: that.numberDisplayed,
                enableFiltering : that.enableFiltering,
                includeSelectAllOption:true,
                onChange:function (option, checked) {
                    console.log('option',jQuery(option[0]).val(),'checked',checked);
                    if (checked) {
                        that.value.push(jQuery(option[0]).val());
                    } else {
                        let vs = that.value.map(String);
                        let val ="" + jQuery(option[0]).val();
                        let idx = vs.indexOf(val);
                        console.log(vs,val,idx);
                        if (idx >=0 )
                            that.value.splice(idx,1)

                    }
                    that.change()
                },
                onSelectAll:function () {
                    Object.assign(that.value,Object.keys(that.domainValues));
                    that.change();
                },
                onDeselectAll:function () {
                    that.value = [];
                    that.change();
                },
            };
            if (that.pluginOptions) {
                for (let k in that.pluginOptions) {
                    pgConf[k] = that.pluginOptions[k];
                }
            }
            that.jQe().find('select').multiselect(pgConf);
            that.jQe().find('.multiselect-container').addClass('w-100');
        }
    }
}
</script>

<style scoped>

</style>
